import React from 'react';
import { LIBRARY_HASH, PACKAGE_ID, PACKAGE_VERSION } from '../data/ledger';
import { useAssessment } from '../contexts/AssessmentContext';
export function Footer() {
  const {
    participantId
  } = useAssessment();
  return <footer className="border-t border-slate-200 bg-white" data-id="element-96" data-mp="32p5nojgp12qd">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-3 gap-y-1 px-6 py-3 font-mono-num text-[11px] text-slate-400" data-id="element-97" data-mp="36p6cmy1f4wbo">
        <span data-id="element-98" data-mp="3ugbrpazjbkkx">
          {PACKAGE_ID} {PACKAGE_VERSION}
        </span>
        <span aria-hidden="true" data-id="element-99" data-mp="398y6cw8527j">·</span>
        <span data-id="element-100" data-mp="37xxwn1zmcl6">library {LIBRARY_HASH}</span>
        <span aria-hidden="true" data-id="element-101" data-mp="3lem0a55nkln5">·</span>
        <span data-id="element-102" data-mp="3ldkeb5n3meqn">participant {participantId || '—'}</span>
      </div>
    </footer>;
}